import { render, staticRenderFns } from "./AssignVehicle.vue?vue&type=template&id=7253242f&"
import script from "./AssignVehicle.vue?vue&type=script&lang=js&"
export * from "./AssignVehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports